export default {
	0: "Pendente",
	1: "Em Andamente",
	2: "Concluido"
};
